import { Card, CardContent, Grid, Typography } from "@material-ui/core";
import React from "react";
import { Delivery } from "../types";
import { formatDisplayDateTime } from "../utils/date";

interface VerificationInfoProps {
  record?: Delivery;
}

const VerificationInfo: React.FC<VerificationInfoProps> = ({ record }) => {
  // Don't render if no verification data or not verified
  if (!record || !record.verify_at) {
    return null;
  }

  const verifiedBy = record.verifyBy?.admin.full_name || "Unknown";
  const verifiedAt = formatDisplayDateTime(record.verify_at);
  const verificationNote =
    (record as any).verification_note || "No note provided";

  return (
    <Card variant="outlined" style={{ marginTop: 16 }}>
      <CardContent style={{ padding: "12px 16px" }}>
        <Typography
          variant="h6"
          gutterBottom
          color="primary"
          style={{ fontSize: "1rem", marginBottom: "8px" }}
        >
          Verification Information
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <Typography variant="caption" color="textSecondary" display="block">
              Verified By
            </Typography>
            <Typography variant="body2">{verifiedBy}</Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="caption" color="textSecondary" display="block">
              Verified At
            </Typography>
            <Typography variant="body2">{verifiedAt}</Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="caption" color="textSecondary" display="block">
              Note
            </Typography>
            <Typography variant="body2">{verificationNote}</Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default VerificationInfo;
